<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="绩效分析" />
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
    >
  <template v-slot:additionalFeatures>
    <div class="table">
      <div>
        <h3 class="workbench-title">销售绩效</h3>
      </div>
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tableData"
            style="width: 100%"
            @sort-change="sortChange"
          >
            <el-table-column prop="name" label="员工"  width="120" fixed="left" />
            <el-table-column prop="shopname" label="门店"  width="140" />
            <el-table-column label="销售" align="center">
              <el-table-column
                width="100"
                prop="salecount"
                label="单数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="countcustome1"
                label="客户数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="real_profit_money1"
                label="毛利"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="num1"
                label="瓶数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="profit_moneyrate1"
                label="毛利率"
                sortable="custom"
              />
            </el-table-column>
            <el-table-column label="出库" align="center">
              <el-table-column
                width="100"
                prop="makecount"
                label="单数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="countcustome2"
                label="客户数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="real_profit_money2"
                label="毛利"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="num2"
                label="瓶数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="profit_moneyrate2"
                label="毛利率"
                sortable="custom"
              />
            </el-table-column>
            <el-table-column label="新增客户(30天)" align="center">
              <el-table-column
                width="100"
                prop="countcustome3"
                label="客户数"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="total_money3"
                label="金额"
                sortable="custom"
              />
              <el-table-column
                width="100"
                prop="real_profit_money3"
                label="毛利"
                sortable="custom"
              />
            </el-table-column>
          </el-table>
    </div>

    <div class="table">
        <div>
          <h3 class="workbench-title">采购绩效</h3>
        </div>
         <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tableData2"
            style="width: 100%"
            @sortChange="sortbuyChange"
          >
            <el-table-column prop="name" label="员工"  />
            <el-table-column prop="shopname" label="门店" />
            <el-table-column label="采购" align="center">
              <el-table-column

                prop="countcustome1"
                label="单数"
                sortable
              />
              <el-table-column

                prop="total_money1"
                label="金额"
                sortable
              />
              <el-table-column

                prop="num1"
                label="瓶数"
                sortable
              />
            </el-table-column>
            <el-table-column label="入库" align="center">
              <el-table-column

                prop="countcustome2"
                label="单数"
                sortable
              />
              <el-table-column

                prop="total_money2"
                label="金额"
                sortable
              />
              <el-table-column

                prop="num2"
                label="瓶数"
                sortable
              />
            </el-table-column>
          </el-table>
    </div>
    <div style="height: 20px"></div>
  </template>
  </basicList>
 </div>
</template>

<script>
  const defaultParameters = {
    page: 1,
    limit: 10000
  };
import { getAllInfo, userSellInfo,alluserSellInfo,alluserBuyInfo,userGetlist, getshoplist} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";

export default {
  name: "allemployeePerformanceAnalysis",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      userName:null,
      // 列表组件参数
      basicListconfig: {
        table: true,
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "指定员工",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
      isPage: false,
      total: 0,
      searchParameters: Object.assign({}, defaultParameters),
      },
      tableData: [],
      tableData2:[],
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
    this.getlist(); // 先拿基础数据，在拉记录
    this.getbuylist();
  },

  methods: {
    sortbuyChange(data) {
      console.log(1);
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
      data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getbuylist();
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
      data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
        this.getbuylist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
          if (key == "time") {
            this.basicListconfig.searchParameters["begin_time"] = data[key]
              ? data[key][0]
              : null;
            this.basicListconfig.searchParameters["end_time"] = data[key]
              ? data[key][1]
              : null;
          }
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
        this.getbuylist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      alluserSellInfo(this.basicListconfig.searchParameters).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.tableData = res.list1;
          //this.tableData2 = res.list2;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    getbuylist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      alluserBuyInfo(this.basicListconfig.searchParameters).then((res) => {
        console.log(res);
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.tableData2 = res.list2;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });

      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/employeePerformanceAnalysis/index.vue